<script setup>
import { router } from '@inertiajs/vue3';
import { BIconFacebook, BIconInstagram, BIconTiktok, BIconTwitter } from 'bootstrap-icons-vue';
import { useI18n } from "vue-i18n";

const programme = router.page.props.ziggy.programme;
const organisation = router.page.props.ziggy.organisation;
const urlNamePrefix = organisation ? "gi." : "";

const default_text = router.page.props.ziggy.default_text;
let home_page_text = null;

const { locale } = useI18n({ useScope: 'global' });

if(default_text) {
    if (organisation) {
        home_page_text = default_text.filter((item) => {
            return item.key == "gi_home_page";
        });
    } else {
        home_page_text = default_text.filter((item) => {
            return item.key == "non_gi_home_page";
        });
    }
    home_page_text = home_page_text[0];
}

function isJsonString(str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}

if (isJsonString(programme.home_page_text)) {
    programme.home_page_text = JSON.parse(programme.home_page_text);
}

if (organisation && organisation.home_page_text && isJsonString(organisation.home_page_text)) {
    organisation.home_page_text = JSON.parse(organisation.home_page_text);
}

</script>

<template>
    <div class="sos-programme-content-card p-8 pb-24 rounded-2xl mt-10">

        <div v-html="organisation.home_page_text[$i18n.locale] ? organisation.home_page_text[$i18n.locale] : organisation.home_page_text[$i18n.fallbackLocale]" v-if="(organisation && organisation.home_page_text)"></div>

        <div v-html="programme.home_page_text[$i18n.locale] ? programme.home_page_text[$i18n.locale] : programme.home_page_text[$i18n.fallbackLocale]" v-if="((!organisation || !organisation.home_page_text) && programme.home_page_text)"></div>

        <div v-html="home_page_text.content[$i18n.locale] ? home_page_text.content[$i18n.locale] : home_page_text.content[$i18n.fallbackLocale]" v-if="(home_page_text && home_page_text.content && ((!organisation || !organisation.home_page_text) && !programme.home_page_text))"></div>

        <div class="organisation-socials" v-if="(organisation && (organisation.twitter || organisation.facebook || organisation.instagram || organisation.tiktok))">
            <p>{{$t('application.general.find_on_social_media', { name: organisation.name })}} </p>
            <a v-if="organisation.twitter" :href="('https://twitter.com/' + organisation.twitter)"><BIconTwitter /></a>
            <a v-if="organisation.facebook" :href="('https://facebook.com/' + organisation.facebook)"><BIconFacebook /></a>
            <a v-if="organisation.instagram" :href="('https://instagram.com/' + organisation.instagram)"><BIconInstagram /></a>
            <a v-if="organisation.tiktok" :href="('https://tiktok.com/' + organisation.tiktok)"><BIconTiktok /></a>
        </div>

        <div class="programme-socials" v-if="(programme.twitter || programme.facebook || programme.instagram || programme.tiktok)">
            <p>{{$t('application.general.find_on_social_media', { name: programme.name })}} </p>
            <a v-if="programme.twitter" :href="('https://twitter.com/' + programme.twitter)"><BIconTwitter /></a>
            <a v-if="programme.facebook" :href="('https://facebook.com/' + programme.facebook)"><BIconFacebook /></a>
            <a v-if="programme.instagram" :href="('https://instagram.com/' + programme.instagram)"><BIconInstagram /></a>
            <a v-if="programme.tiktok" :href="('https://tiktok.com/' + programme.tiktok)"><BIconTiktok /></a>
        </div>

    </div>
</template>
